import { json, useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const ViewSalesOrder = () => {
  const navigate = useNavigate();

  const [viewSalesOrder, setViewSalesOrder] = useState({});

  let [token, setToken] = useState("");
  const resource = "view-sales-order";
  const [salesOrderDate, setSalesOrderDate] = useState("");
  const [salesOrderMSADate, setSalesOrderMSADate] = useState("");
  const [error, setError] = useState(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [specifiedTc, setSpecifiedTc] = useState("");
  const [salesOrderSign, setSalesOrderSign] = useState("");
  const [vat, setVat] = useState();

  useEffect(() => {
    const fetchVat = async () => {
      try {
        const key = "XCP_VAT";
        const result = await axios.get(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/configuration/find-by-key?key=${key}`
        );

        const responseVat = result.data.find(
          (item) => item.xcp_key === "XCP_VAT"
        )?.xcp_value;

        setVat(responseVat);
      } catch (error) {
        console.error("Error fetching vat:", error);
      }
    };

    fetchVat();
  }, []);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);

    const checkSessionToken = async () => {
      try {
        const response = await fetch(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/auth/check-session?token=${storedToken}&resource=${resource}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          setError(data.message || "Failed to fetch session token data");
          throw new Error(data.message || "Failed to fetch session token data");
        }

        // Parse response text as a boolean value
        const text = await response.text();
        const data = text === "true";

        if (data) {
        } else {
          window.alert("Session is invalid");
          navigate("/login");
        }
      } catch (error) {
        console.error("Fetch Error:", error.message);
        setError("Fetch Error: " + error.message);
      }
    };

    checkSessionToken();
  }, []);

  function formatDate(dateString) {
    const dateObj = new Date(dateString);
    if (isNaN(dateObj)) return ""; // Handle invalid date

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [previousPage, setPreviousPage] = useState("");

  useEffect(() => {
    const prev = sessionStorage.getItem("previousPage");
    if (prev) {
      setPreviousPage(prev);
    }
  }, []);

  useEffect(() => {
    loadViewSalesOrder(searchParams.get("param1"));
  }, []);

  const loadViewSalesOrder = async (xcpOrderId) => {
    try {
      const result = await axios.get(
        `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/order/view-sales-order?param1=${xcpOrderId}`
      );

      const data = result.data;
      setSalesOrderDate(formatDate(data.xcp_sales_order_date));
      setSalesOrderMSADate(formatDate(data.xcp_sales_order_msa_date));
      setSelectedOption(data.xcp_sales_order_tc_option);
      setSpecifiedTc(data.xcp_sales_order_tc);

      data.orderItemlistByOrderId.forEach((item) => {
        const cable_type_a = item.cable_type_a;
        const a_end_rack_id = item.a_end_rack_id;
        const company_requestor = data.company_requestor;
        const interface_name_a = item.interface_name_a;

        const cable_type_b = item.cable_type_b;
        const b_end_rack_id = item.b_end_rack_id;
        const company_destination = data.company_destination;
        const interface_name_b = item.interface_name_b;

        item.service_description =
          "Location: " +
          data.order_location_name +
          "\nCross Connect using " +
          cable_type_a +
          " :\nFrom: " +
          a_end_rack_id +
          " (" +
          company_requestor +
          ") Interface type " +
          interface_name_a +
          "\n\nCross Connect using " +
          cable_type_b +
          " :\nTo: " +
          b_end_rack_id +
          " (" +
          company_destination +
          ") Interface type " +
          interface_name_b;
      });
      setViewSalesOrder(data);
    } catch (error) {
      console.error("Fetch Error Order Detail:", error);
      setError("Fetch Error Order Detail: " + error.message);
    }
  };

  const formatCurrency = (value) => {
    // Gunakan Intl.NumberFormat untuk memformat angka
    const formatted = new Intl.NumberFormat("id-ID", {
      minimumFractionDigits: 0, // Tidak ada angka desimal
    }).format(value);

    return formatted; // Langsung kembalikan hasil tanpa simbol mata uang
  };

  useEffect(() => {
    currencySelected(viewSalesOrder.xcp_sales_order_currency);
  }, [viewSalesOrder]);

  function currencySelected(currency) {
    if (currency === "IDR") {
      setSelectedCurrency("IDR");
    } else if (currency === "USD") {
      setSelectedCurrency("USD");
    }
  }

  const handleBackClick = () => {
    navigate(previousPage);
  };

  useEffect(() => {
    const fetchSalesOrderSign = async () => {
      try {
        const key = "NTT_STAMP";
        const result = await axios.get(
          `https://lbhaw84n6b.execute-api.ap-southeast-3.amazonaws.com/xcp/master/configuration/find-by-key?key=${key}`
        );
  
        const salesOrderSignUrl = result.data.find(
          (item) => item.xcp_key === "NTT_STAMP"
        )?.xcp_value;
  
        setSalesOrderSign(salesOrderSignUrl);
      } catch (error) {
        console.error("Error fetching sales order sign:", error);
      }
    };
  
    fetchSalesOrderSign();
  }, []);
  

  return (
    <div className="container-order-input">
      <h1 className="main-title">Cross Connect Sales Order</h1>
      <div className="box-two-part">
        <div className="requestor-information">
          <div className="title-order-input">
            <h5>Sales Order Header</h5>
          </div>
          <div className="textbox">
            <label htmlFor="officeAddress">Customer</label>
            <textarea
              style={{
                backgroundColor: "lightgrey",
                color: "black",
                height: "169px",
              }}
              value="PT. NTT Indonesia 
Wisma 46-Kota BNI, 5th Floor 
Jl. Jenderal Sudirman Kav. 1
Jakarta 10220"
              disabled
            ></textarea>
          </div>
          <div className="textbox-gray">
            <label htmlFor="companyName">Name</label>
            <input
              type="text"
              value={viewSalesOrder.xcp_sales_order_destination}
              required
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label>Sales Order MSA Date</label>
            <input type="text" value={salesOrderMSADate} disabled />
          </div>
        </div>

        <div className="destination-information">
          <div className="title-order-input">
            <h5 style={{ visibility: "hidden" }}>.</h5>
          </div>
          <div className="textbox-gray">
            <label htmlFor="salesOrderNo">Sales Order No</label>
            <input
              type="text"
              id="salesOrderNo"
              value={viewSalesOrder.xcp_sales_order_no}
              required
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="orderDate">Date</label>
            <input
              type="text"
              id="salesOrderDate"
              value={salesOrderDate}
              required
              disabled
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="picName">Prepared By</label>
            <input
              type="text"
              value={viewSalesOrder.xcp_sales_order_prepare_by}
              disabled
            />
          </div>
          <div className="radio-button">
            <label>Sales Order Currency</label>
            <div>
              <input
                type="radio"
                name="connect"
                id="connect-one"
                checked={selectedCurrency === "IDR"}
                disabled
              />
              <label>IDR</label>
            </div>
            <div>
              <input
                type="radio"
                name="connect"
                id="connect-two"
                checked={selectedCurrency === "USD"}
                disabled
              />
              <label>USD</label>
            </div>
          </div>
        </div>
      </div>

      {viewSalesOrder.orderItemlistByOrderId &&
        viewSalesOrder.orderItemlistByOrderId.length > 0 &&
        viewSalesOrder.orderItemlistByOrderId.map((order, index) => (
          <div className="box-two-part">
            <div className="requestor-information">
              <div className="title-order-input">
                <h5>Cross Connect Service ({index + 1})</h5>
              </div>
              <div className="textbox">
                <label htmlFor="officeAddress">Service Description</label>
                <textarea
                  style={{
                    backgroundColor: "lightgrey",
                    color: "black",
                    height: "190px",
                  }}
                  disabled
                  value={order.service_description}
                ></textarea>
              </div>
              <div className="textbox-gray">
                <label htmlFor="companyName">Month</label>
                <input type="number" value={order.month} required disabled />
              </div>

              <div className="textbox-gray">
                <label htmlFor="picName">Quantity</label>
                <input type="number" value={order.cable_quantity} disabled />
              </div>
              <div className="textbox-gray">
                <label htmlFor="companyName">Unit</label>
                <input type="text" value={order.unit} required disabled />
              </div>
            </div>

            <div className="destination-information">
              <div className="title-order-input">
                <h5 style={{ visibility: "hidden" }}>.</h5>
              </div>
              <label htmlFor="nrc" style={{ fontSize: "18px" }}>
                NRC Charging Scheme
              </label>
              <div className="textbox-gray">
                <label htmlFor="nrc">Unit Price ({selectedCurrency})</label>
                <input
                  type="text"
                  value={formatCurrency(order.sales_order_nrc_unit_price)}
                  required
                  style={{ textAlign: "right" }}
                  disabled
                />
              </div>
              <div className="textbox-gray">
                <label htmlFor="picName">Subtotal ({selectedCurrency})</label>
                <input
                  type="text"
                  value={formatCurrency(order.sales_order_nrc_sub_total)}
                  style={{ textAlign: "right" }}
                  disabled
                />
              </div>
              <div className="textbox-gray">
                <label htmlFor="picName">Vat {vat}%  ({selectedCurrency})</label>
                <input
                  type="text"
                  value={formatCurrency(order.sales_order_nrc_tax)}
                  required
                  disabled
                  style={{ textAlign: "right" }}
                />
              </div>

              <div className="title-order-input"></div>
              <label htmlFor="picName" style={{ fontSize: "18px" }}>
                MRC Charging Scheme
              </label>
              <div className="textbox-gray">
                <label htmlFor="picName">Unit Price ({selectedCurrency})</label>
                <input
                  type="text"
                  value={formatCurrency(order.sales_order_mrc_unit_price)}
                  required
                  style={{ textAlign: "right" }}
                  disabled
                />
              </div>
              <div className="textbox-gray">
                <label htmlFor="picName1">Subtotal ({selectedCurrency})</label>
                <input
                  type="text"
                  value={formatCurrency(order.sales_order_mrc_sub_total)}
                  style={{ textAlign: "right" }}
                  disabled
                />
              </div>
              <div className="textbox-gray">
                <label htmlFor="picName2">Vat {vat}% ({selectedCurrency})</label>
                <input
                  type="text"
                  value={formatCurrency(order.sales_order_mrc_tax)}
                  disabled
                  style={{ textAlign: "right" }}
                />
              </div>
            </div>
          </div>
        ))}
      <div className="box-two-part">
        <div className="requestor-information">
          <div className="title-order-input">
            <h5>Agreement Details</h5>
          </div>
          <div className="radio-button">
            <label>Terms & Conditions</label>
            <div>
              <input
                type="radio"
                name="tc"
                id="general-tc"
                value="GENERAL"
                checked={selectedOption === "GENERAL"}
                disabled
              />
              <label htmlFor="general-tc">Use general terms & conditions</label>
            </div>
            <div>
              <input
                type="radio"
                name="tc"
                id="specified-tc"
                value="SPECIFIED"
                checked={selectedOption === "SPECIFIED"}
                disabled
              />
              <label htmlFor="specified-tc">Specified T&C</label>
            </div>
            <textarea
              placeholder={
                selectedOption === "SPECIFIED"
                  ? "Enter specified terms & conditions"
                  : ""
              }
              value={specifiedTc}
              onChange={(e) => setSpecifiedTc(e.target.value)}
              style={{
                width: "100%",
                marginTop: "8px",
                padding: "8px",
                height: "400px",
              }}
              disabled
              required
            />
          </div>
        </div>

        <div className="destination-information">
          <div className="title-order-input">
            <h5 style={{ visibility: "hidden" }}>.</h5>
          </div>
        </div>
      </div>

      <div className="box-two-part">
        <div className="requestor-information">
          <div className="title-order-input">
            <h5>Total Project Value</h5>
          </div>
          <div className="textbox-gray">
            <label htmlFor="picName">Total NRC ({selectedCurrency})</label>
            <input
              type="text"
              value={formatCurrency(viewSalesOrder.xcp_sales_order_nrc_total)}
              disabled
              style={{ textAlign: "right" }}
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="picName">Total MRC ({selectedCurrency})</label>
            <input
              type="text"
              value={formatCurrency(viewSalesOrder.xcp_sales_order_mrc_total)}
              disabled
              style={{ textAlign: "right" }}
            />
          </div>
          <div className="textbox-gray">
            <label htmlFor="picName">Vat {vat}% ({selectedCurrency})</label>
            <input
              type="text"
              value={formatCurrency(viewSalesOrder.xcp_sales_order_tax_total)}
              disabled
              style={{ textAlign: "right", padding: "5px" }}
            />
          </div>
        </div>
      </div>
      {["Installation", "Complete"].includes(
        viewSalesOrder.xcp_order_status_name
      ) && (
        <div className="box-two-part">
          <div className="requestor-information">
            <div className="title-order-input">
              <h5>Sales Order Signature</h5>
            </div>
            <div className="textbox-gray">
              <label htmlFor="picName">Authorized By</label>
              <img
                src={salesOrderSign}
                alt="Signature"
                style={{ maxWidth: "100%", height: "auto" }}
              />
              <label style={{ fontFamily: 'Segoe Script', fontSize: 35, marginTop: "-20px"}}>{viewSalesOrder.xcp_sales_order_destination}</label>

              {/* <label>{viewSalesOrder.xcp_sales_order_destination}</label> */}
            </div>
          </div>
        </div>
      )}
      <input
        type="button"
        className="btn-submit-order-input"
        value="Back"
        onClick={handleBackClick}
      />
    </div>
  );
};

export default ViewSalesOrder;
